import React, { useEffect, useState } from "react";
import { Typography, Box, Button } from '@mui/material';
import { Dialog, useToggle } from '@genesis/ui-kit';
import axios from "axios";
import axiosInstance from "../../../../Shared/Utill/AxiosConfig";
import { constants, environmentVariables } from "../../../../Shared/Url/Constants";
import { useSelector } from "react-redux";
import Cookie from "js-cookie";
import { IsTokenValid } from "../../../../Shared/Utill/AuthUtil";
import moment from 'moment';

const BulkUpdateDialog = (props) => {
    const dialog = useToggle();
    const personDetails = useSelector((state) => state.person.personData);
    const urlDetails = useSelector((state) => state.url.urlData);
    const token = Cookie.get('X_TKN');
    const [isAlertOpen, setAlertOpen] = React.useState({});
    const { message, severity, open } = isAlertOpen || {};
    console.log("testing location info",props.locationInfo)

    useEffect(() => {
        dialog.show();
    }, []);

    const bulkUpdateAction = () => {
        // call delet event  api
        console.log("request payload",props)
        callBulkUpdateService(props);
       
    }

    const callBulkUpdateService = (props) =>{
       
               //alert("data saving")
               let len = Object.keys(props.startHours).length;
               let eventHours = [];
               for (let i = 1; i <= len; i++) {
                   let tmp = {};
                   tmp.seqNbr = i;
                   tmp.ctlName = "ddeventdayhrs";
                   tmp.value1 = props.startHours[i];
                   tmp.value2 = props.endHours[`end-${i}`]
                   eventHours.push(tmp)
               }
               console.log(eventHours);
            
               const isEventHoursNull = Object.values(eventHours).some(x => (x.value1 === null && x.value2 !== null));
               const isEventHoursNull2 = Object.values(eventHours).some(x => (x.value1 !== null && x.value2 == null));
             
               console.log("fun1")
               
               if (isEventHoursNull || isEventHoursNull2) {
                props.onCloseDialog()
                props.onBulkUpdateCallback("error","Event Hours needs both fields to have values or none")
               } else {
                console.log("fun3",props.activateEvent)
       
                let momentEventStartDate = moment(props.eventStartDate).format('MM/DD/YYYY');
                let momentEventEndDate = moment(props.eventEndDate).format('MM/DD/YYYY');
                let momentDisplayStartDate = moment(props.displayStartDate).format('MM/DD/YYYY');
                let momentDisplayEndDate = moment(props.displayEndDate).format('MM/DD/YYYY');
                let activeEvent;
                let splitShift;
                let forceMinShiftHrs;
                let allowPartialShiftSelection;
                let scheduleDepartment;
                let workScheduleDepartment;
                let eventDetailsUnavailableActive;
                console.log("eventStatus",props.activateEvent)
                console.log("allowSplitShift",props.splitShift)
                 if (props.activateEvent === "Active") {
                     activeEvent = "y";
                 } else if (props.activateEvent === "No Change") {
                     activeEvent = null;
                 } else {
                    activeEvent = "n";
                 } 
                 
                 if (props.splitShift === "On") {
                     splitShift = "y";
                 } else if (props.splitShift === "No Change") {
                    splitShift = null;
                } else {
                     splitShift = "n";
                 }
                 if (props.forceMinShiftHrs === "Yes") {
                     forceMinShiftHrs = "y";
                 }  else if (props.forceMinShiftHrs === "No Change") {
                    forceMinShiftHrs = null;
                } else {
                     forceMinShiftHrs = "n";
                 }
                 if (props.allowPartialShiftSelection === "Yes") {
                     allowPartialShiftSelection = "y";
                 }  else if (props.allowPartialShiftSelection === "No Change") {
                    allowPartialShiftSelection = null;
                } else {
                     allowPartialShiftSelection = "n";
                 }
                 if (props.scheduleDepartment === "Include") {
                    scheduleDepartment = "y";
                }  else if (props.scheduleDepartment === "No Change") {
                    scheduleDepartment = null;
               } else {
                    scheduleDepartment = "n";
                }
                if (props.workScheduleDepartment === "Include") {
                    workScheduleDepartment = "y";
                }  else if (props.workScheduleDepartment === "No Change") {
                    workScheduleDepartment = null;
               } else {
                    workScheduleDepartment = "n";
                }

                if (props.colleagueUnavailability === "Yes") {
                    eventDetailsUnavailableActive = "y";
                } else if (props.colleagueUnavailability === "No Change") {
                    eventDetailsUnavailableActive = null;
                } else {
                    eventDetailsUnavailableActive = "n";
                } 

                let data = {
                    eventId: props.eventId !== null ? props.eventId : "",
                    eventDetailsEventStartDate: momentEventStartDate !== "Invalid date" ? momentEventStartDate : "",
                    eventDetailsEventEndDate: momentEventEndDate !== "Invalid date" ? momentEventEndDate : "",
                    eventDetailsDisplayStartDate: momentDisplayStartDate !== "Invalid date" ? momentDisplayStartDate : "",
                    eventDetailsDisplayEndDate: momentDisplayEndDate !== "Invalid date" ? momentDisplayEndDate : "",
                    eventDetailsActive: activeEvent, 
                    shiftsDropDownIntervals: props.shiftsDropDownIntervals,
                    shiftsAllowSplitShifts: splitShift,
                    shiftsMinimumSelectionHours: props.shiftsMinimumSelectionHours,
                    shiftsForceMinimumSelectionHours: forceMinShiftHrs,
                    eventHours: eventHours,
                    eventHoursAllowPartialShiftSelection: allowPartialShiftSelection,
                    scheduleAreasDptValues: props.scheduleArea,
                    scheduleAreasDptIncluded: scheduleDepartment,
                    workScheduleWsIncluded: workScheduleDepartment,
                    workScheduleWsValues: props.workSchedule,
                    lastUpdatedBy: "BulkUpdate",
                    eventDetailsUnavailableActive: eventDetailsUnavailableActive
                }
                console.log(data)
                console.log("made it to post")
               
    
    
                axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_EVENT_CONTROL_BULK_UPDATE}`,
                    data,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token,
                        }
                    }).then((res) => {
                        // call api to fetch data
                        if(res.status === 200) {
                            closeDialog()
                            props.onBulkUpdateCallback("success","All locations in this event were updated successfully.")
                        } else {
                         props.onCloseDialog()
                         props.onBulkUpdateCallback("error","Something went wrong")
                        }
                    }).catch((err) => {
                        //alert("error")
                        props.onCloseDialog()
                        props.onBulkUpdateCallback("error",err.response.data.message)
                    });
               }
                
               

    }
  
    
    const closeDialog = () => {
        dialog.hide();
        props.onCloseDialog(); 
    }
    return (
        <Box>
            <Dialog
                open={dialog.open}
                title={"Confirm Bulk Update"}
                onClose={closeDialog}
                actions={
                    <>
                        <Button color="secondary" onClick={() => closeDialog()}>No</Button>
                        <Button onClick={() => bulkUpdateAction()}>Yes</Button>
                    </>
                }
            >
                <Typography>{`Are you sure you want to bulk update this event which includes ${props.locationInfo.location_count} locations?`}</Typography>
            </Dialog>
        </Box>
    );
}

export default BulkUpdateDialog;

